import styled from "styled-components";

export const Button = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  height: 20px;
  margin: 0;
  padding: 0;
  width: 20px;
`;
